import Repository from "./Repository";

const resource = "/user";

export default {
    // get(){
    //     return Repository.get(`${resource}`);
    // },
    post(payload){
        return Repository.post(`${resource}`,payload);
    },
    get(payload){
        return Repository.get(`${resource}/${payload}`);
    },
    getByEmail(payload){
        return Repository.get(`${resource}?email=${payload.email}`);
    },
    patch(payload){
        return Repository.patch(`${resource}/${payload.id}`,payload);
    },
    postSendEmail(payload){
        return Repository.post(`${resource}/send-email`,payload);

    }
}